export const PENDING_NOTES_DEFAULT_VISIBLE_COUNT = 5;
export const ALERTS_DEFAULT_VISIBLE_COUNT = 5;

export const DASHBOARD_V2_GRID = {
  templateColumns: '3fr 2fr',
  gap: '20px',
} as const;

export const CARD_STYLES = {
  bg: 'white',
  borderWidth: '1px',
  borderColor: 'neutral.line',
  borderRadius: '16px',
  boxShadow: '0 0 8px 0 rgba(0, 0, 0, 0.08)',
} as const;

export const CARD_CONTENT_MIN_HEIGHT = {
  myDay: '99px',
  pendingNotes: '200px',
  myPatients: '200px',
  alerts: '200px',
} as const;

export const EMPTY_STATE_COPY = {
  alerts: {
    title: 'No patients need attention',
    body: 'Patients who need your attention will appear here.',
  },
  myDay: {
    title: 'No sessions today',
    body: 'You have no patient sessions scheduled for today.',
  },
  pendingNotes: {
    title: "You're all caught up",
    body: 'You have no pending notes remaining. New draft notes will appear here.',
  },
  myPatients: {
    allEmpty: {
      title: 'No patients to display',
      body: 'You currently have no active patients.',
    },
    todayTab: {
      title: 'No patients to display',
      body: 'You have no patient sessions scheduled for today. Try a different filter or view your full caseload.',
      ctaLabel: 'View all active patients',
    },
    filteredTab: {
      title: 'No patients to display',
      body: 'None of your patients currently match these criteria. Try a different filter or view your full caseload.',
      ctaLabel: 'View all my patients',
    },
  },
} as const;

export const PATIENT_VIEWS = {
  active: 'active',
  today: 'today',
  new: 'new',
  paused: 'paused',
  reassigned: 'reassigned',
  unpaused: 'unpaused',
  upcomingDischarge: 'upcoming-discharge',
} as const;

export type PatientViewKey = (typeof PATIENT_VIEWS)[keyof typeof PATIENT_VIEWS];

export const DASHBOARD_TABS: { key: PatientViewKey; label: string }[] = [
  { key: PATIENT_VIEWS.active, label: 'Total active patients' },
  { key: PATIENT_VIEWS.today, label: "Today's sessions" },
  { key: PATIENT_VIEWS.new, label: 'New patients' },
  { key: PATIENT_VIEWS.paused, label: 'Paused patients' },
  { key: PATIENT_VIEWS.reassigned, label: 'Reassigned patients' },
  { key: PATIENT_VIEWS.unpaused, label: 'Unpaused patients' },
  {
    key: PATIENT_VIEWS.upcomingDischarge,
    label: 'Upcoming discharge\nsessions',
  },
];

export const COLOR_LEVELS: Record<string, { label: string; hex: string }> = {
  purple: { label: 'Purple', hex: '#6910C6' },
  red: { label: 'Red', hex: '#C61910' },
  orange: { label: 'Orange', hex: '#EFA53A' },
  yellow: { label: 'Yellow', hex: '#FFC52E' },
  blue: { label: 'Blue', hex: '#2266FF' },
  teal: { label: 'Teal', hex: '#007F79' },
  green: { label: 'Green', hex: '#1ED32C' },
};

export const SEVERITY_ORDER = [
  'purple',
  'red',
  'orange',
  'yellow',
  'blue',
  'teal',
  'green',
];

export const STATUS_KEYS = [
  'fulfilled',
  'cancelledByPatient',
  'noShow',
  'upcoming',
] as const;

export type StatusKey = (typeof STATUS_KEYS)[number];

export type AppointmentStatusCounts = Record<StatusKey, number> & {
  total: number;
};

export const STATUS_COLORS: Record<StatusKey, string> = {
  fulfilled: '#0C8D19',
  cancelledByPatient: '#EFA53A',
  noShow: '#C61910',
  upcoming: '#007F79',
};

export const STATUS_LABELS: Record<StatusKey, string> = {
  fulfilled: 'Completed',
  cancelledByPatient: 'Cancelled by patient',
  noShow: 'No show',
  upcoming: 'Upcoming',
};
